import React from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'
import styled from '@emotion/styled'
import cn from 'classnames'

import { ENTER } from 'constants/keys'
import { moveCursorToEnd } from 'util/forms'
import { runOnNextTick } from 'util/functions'
import { stopEvent } from 'util/keys'

class SubjectInput extends React.Component {
  static propTypes = {
    // The current draft. Primarily used to get and track changes to title
    draft: PropTypes.object, // eslint-disable-line react/forbid-prop-types

    // The current draft id
    draftId: PropTypes.string,

    // Whether to focus the field after mounting
    startFocused: PropTypes.bool,

    /** Called when field value changed. Use this to provide a callback to
     * update your draft title */
    onChange: PropTypes.func,

    /** Called Enter key pressed. E.g. can be used to focus the editor */
    onEnter: PropTypes.func,
  }

  static defaultProps = {
    draft: null,
    draftId: null,
    startFocused: false,
    onChange: undefined,
    onEnter: undefined,
  }

  // eslint-disable-next-line react/sort-comp
  getDraftValue = () => {
    return (
      (this.props.subject !== undefined ? this.props.subject : null) ||
      (this.props.draft && this.props.draft.title)
    )
  }

  state = {
    draftValue: this.getDraftValue(),
  }

  componentDidMount() {
    if (this.props.startFocused) this.focus()
  }

  componentWillReceiveProps(newProps) {
    const { draft, ticketId, subject } = newProps
    if (ticketId !== this.props.ticketId) this.input.value = null
    if (draft) this.input.value = draft.title || null
    if (subject) this.input.value = subject || null
  }

  onKeyPressEnter(e) {
    const { onEnter } = this.props
    if (!onEnter) return false
    stopEvent(e)
    return onEnter()
  }

  getAndSave = () => {
    const value = this.getInput().value
    this.changeDraftValue(value)
  }

  getInput = () => {
    // eslint-disable-next-line react/no-find-dom-node
    return ReactDOM.findDOMNode(this.input)
  }

  handleKeyDown = e => {
    if (e.keyCode === ENTER) this.onKeyPressEnter(e)
    runOnNextTick(this.getAndSave)
  }

  handlePaste = () => {
    runOnNextTick(this.getAndSave)
  }

  changeDraftValue = newValue => {
    const { draftId, onSubjectChange } = this.props
    if (onSubjectChange) {
      onSubjectChange(draftId, newValue)
      return
    }
    const currentValue = this.state.draftValue

    if (currentValue !== newValue) {
      this.setState({ draftValue: newValue })
      this.props.onChange(newValue)
    }
  }

  focus = () => {
    this.getInput().focus()
  }

  saveRef = node => {
    this.input = node
  }

  render() {
    const { className, placeholder, tabIndex } = this.props
    const draftValue = this.state.draftValue || null

    return (
      <input
        className={cn(className, 'grui truncate')}
        defaultValue={draftValue}
        id="subject"
        onFocus={moveCursorToEnd}
        onKeyDown={this.handleKeyDown}
        onPaste={this.handlePaste}
        placeholder={placeholder}
        ref={this.saveRef}
        tabIndex={tabIndex}
        maxLength="191"
      />
    )
  }
}

export default styled(SubjectInput)`
  &&& {
    background-color: inherit;
    border: 0;
    color: inherit;
    flex-grow: 1;
    font-size: 13px;
    font: inherit;
    line-height: 1.38 !important;
    min-width: 200px;
    outline: 0;
    padding: 0;
    width: 100%;

    ::placeholder {
      color: ${props => props.theme.color.monochrome.mediumDark};
    }
  }
`
